<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import env from "@/env.js";
import { useFetch } from "@/api/fetch.js";
import { redirectToAdminApp } from "@/utils.js";

const route = useRoute();
const router = useRouter();
const { postJson } = useFetch();

const loading = ref(true);
const info = ref("正在登录体验店...");

onMounted(async () => {
  const sampleName = route.query.sampleName;
  const sample = env.getSampleLogin(sampleName);
  if (!sample) {
    info.value = "体验店参数无效";
    loading.value = false;
    return;
  }

  const res = await postJson("wxScan", "loginChain", {
    chainId: sample.chainId,
    sampleName: sample.name,
    sample: true,
  });

  if (res?.info === "OK") {
    info.value = "登录成功，正在进入系统...";
    redirectToAdminApp(res);
  } else {
    info.value = res?.info || res?.error || "登录失败";
    loading.value = false;
  }
});
</script>

<template>
  <v-container class="sample-page">
    <div class="state-box">
      <v-progress-circular v-if="loading" indeterminate color="primary" />
      <p class="mt-4 text-grey-darken-1">{{ info }}</p>
      <v-btn v-if="!loading" color="primary" variant="text" @click="router.push({ name: '统一登录' })">
        返回登录
      </v-btn>
    </div>
  </v-container>
</template>

<style scoped>
.sample-page {
  min-height: 100vh;
  max-width: 560px;
  padding-top: 80px;
}

.state-box {
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
